export function hasPermission(user, target, action) {
  return user?.roles?.some(r => {
    return r?.permissions.find(p => {
      return p.target ===  target && p.action === action;
    });
  });
}
